import apiClient from "../../apiClient";
import {
  CommissionType,
  CreateCommissionTypeRequest,
  UpdateCommissionTypeRequest,
  CommissionTypesResponse,
  Commission,
  CreateCommissionRequest,
  UpdateCommissionRequest,
  CommissionsResponse,
} from "./types";

class CommissionTypesService {
  // Commission Types
  async getCommissionTypes(params?: {
    skip?: number;
    limit?: number;
    name?: string;
  }): Promise<CommissionTypesResponse> {
    const response = await apiClient.get(`commission-types`, { params });
    return response.data;
  }

  async getCommissionTypeById(id: string): Promise<CommissionType> {
    const response = await apiClient.get(`commission-types/${id}`);
    return response.data;
  }

  async createCommissionType(
    data: CreateCommissionTypeRequest,
  ): Promise<CommissionType> {
    const response = await apiClient.post(`commission-types`, data);
    return response.data;
  }

  async updateCommissionType(
    id: string,
    data: UpdateCommissionTypeRequest,
  ): Promise<CommissionType> {
    const response = await apiClient.put(`commission-types/${id}`, data);
    return response.data;
  }

  async deleteCommissionType(id: string): Promise<void> {
    await apiClient.delete(`commission-types/${id}`);
  }

  // Commissions
  async getCommissions(params?: {
    skip?: number;
    limit?: number;
    playerId?: string;
    agentId?: string;
    commissionTypeId?: string;
    isActive?: boolean;
  }): Promise<CommissionsResponse> {
    const response = await apiClient.get(`commissions`, { params });
    return response.data;
  }

  async getCommissionById(id: string): Promise<Commission> {
    const response = await apiClient.get(`commissions/${id}`);
    return response.data;
  }

  async createCommission(data: CreateCommissionRequest): Promise<Commission> {
    const response = await apiClient.post(`commissions`, data);
    return response.data;
  }

  async updateCommission(
    id: string,
    data: UpdateCommissionRequest,
  ): Promise<Commission> {
    const response = await apiClient.put(`commissions/${id}`, data);
    return response.data;
  }

  async deleteCommission(id: string): Promise<void> {
    await apiClient.delete(`commissions/${id}`);
  }
}

export const commissionTypesService = new CommissionTypesService();
